<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZmyJaL/tc-custom/9781488079191.jpg?1724852547573" alt="This image is the cover for the book Hold Her Again"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hold Her Again
      </h1>
      <p class="bookDescription body article font2">
        <b>A country-music star returns home to win back the woman he loves in this charming holiday novella from </b><b><i>New York Times</i></b><b> bestselling author Shannon Stacey</b><br/><br/>Ava Wright isn’t happy to see her high school sweetheart rolling into their hometown a few weeks before Christmas. He’s only come back to bury his estranged father, but there’s no way she’ll be able to avoid him. No one can: he’s become a country-music superstar since going solo and leaving Ava behind.<br/><br/>Jace Morrow grew up believing “money can’t buy happiness” was something people said to make themselves feel better. But now he knows it’s the truth: no matter how many number-one hits he has, he’ll never recapture the magic of singing with Ava. Missing her—loving her—and living with making the wrong choice in life were what made him who he is.<br/><br/>When Jace is roped into being part of the town’s annual Christmas party, he only cares about earning Ava’s forgiveness. And though Ava’s heart has never healed, she loved Jace too much and for too long to shut him out when he’s hurting. As they fall in love all over again, they’re both faced with choices for their future…and this time Jace intends to make the right one.<br/><br/>This book is approximately 30,000 words<br/><br/><i>One-click with confidence. This title is part of the </i><b><i>Carina Press Romance Promise</i></b><i>: all the romance you’re looking for with an HEA/HFN. It’s a promise!</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shannon Stacey
      </h2>
      
      <p class="authorDescription body article"><I>New York Times&#160;</I>and <I>USA Today</I> bestselling author Shannon Stacey lives with her husband and two sons in New England, where her two favorite activities are writing stories of happily ever after and off-roading with her friends and family. You can contact Shannon through her website, www.shannonstacey.com, as well as sign up for her newsletter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18a32947